/**
 * Recortes de interface a partir das permissões já emitidas na sessão.
 * O servidor continua sendo a autorização real — isto só esconde o inalcançável.
 */
export interface Visao {
  colaborador: boolean;
  alocar: boolean;
  mapa: boolean;
}

export function resolverVisao(pode: (permission: string) => boolean): Visao {
  return {
    colaborador:
      pode('escala:ver_propria') && !pode('escala:ver_equipe') && !pode('escala:ver_todas'),
    alocar: pode('reserva:criar_individual') || pode('escala:editar_equipe'),
    mapa: pode('mapa:ver_disponibilidade'),
  };
}
